<template>
  <div class="d-emails">
    <h3 class="h3 mt0">Email Activity</h3>
    <module-spinner
      :active="loading"
      :floating="true"
    />

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="emailActivityLength > 0"

        key="emails-table"
      >
        <module-table
          :columns="columns"
          :rows="emailActivity.results"
        />

        <div class="d-emails__more">
          <p class="p">Showing <strong>{{ emailActivityLength }}</strong> of <strong>{{ emailActivityTotal }}</strong> Results</p>
          <module-button
            v-if="emailActivity.next"

            @click.native="getNextPage"

            button="primary"
            label="Load more"
            :loading="loading"
          />
        </div>
      </div>
      <p v-else-if="emailActivityLength === 0 && !loading" class="fw-bold mt2">No Email Activity</p>
    </transition>
  </div>
</template>

<script>
// UA Parser
import parser from 'ua-parser-js'; 
// Vuex
import { mapActions, mapGetters } from 'vuex';

// Services
import { toDateTimeString, toDateString } from 'services/dateTime';

// Modules
import ModuleDetailList from 'modules/DetailList';
import ModuleButton from 'modules/Button';
import ModuleSpinner from 'modules/Spinner';
import ModuleTable from 'modules/Table';

// Export
export default {
  name: `ui-dashboard-email-activity`,

  // Components
  components: {
    ModuleDetailList,
    ModuleButton,
    ModuleSpinner,
    ModuleTable,
  },

  // Data
  data() {
    return {
      loading: true,
    };
  },

  // Computed
  computed: {
    ...mapGetters(`emails`, [
      `emailActivity`,
      `emailActivityLength`,
      `emailActivityTotal`,
    ]),
    columns() {
      return [
        {
          heading: `Acitivity Type`,
          value: request  => this.getActivityType(request),
        },
        {
          heading: `Operating System`,
          value: request  => this.getOSFromUA(request.user_agent),
        },
        {
          heading: `Browser`,
          value: request  => this.getBrowserFromUA(request.user_agent),
        },
        {
          heading: `IP Address`,
          value: request  => request.ip_address ? request.ip_address : `N/A`, 
        },
        {
          heading: `Date`,
          value: request => `${toDateString(request.created_at)} ${toDateTimeString(request.created_at)}`,
        },
      ];
    },
  },

  // Methods
  methods: {
    ...mapActions(`emails`, [
      `getEmailActivity`,
    ]),
    getBrowserFromUA(userAgent) {
      if (! userAgent) {
        return `N/A`;
      }

      const name = (parser(userAgent).browser || { name: `Unknown` }).name;
      const version = (parser(userAgent).browser || { version: `Unknown` }).version;

      return `${name} ${version}`;
    },
    getOSFromUA(userAgent) {
      if (! userAgent) {
        return `N/A`;
      }
      const name = (parser(userAgent).os || { name: `Unknown` }).name;
      const version = (parser(userAgent).os || { version: `Unknown` }).version;

      return `${name} ${version}`;
    },
    getActivityType(request) {
      let named_type = `Viewed`;
      switch(request.type) {
      case 1:
        named_type = `Sent`;
        break;
      case 2:
        named_type = `Viewed`;
        break;
      case 3:
        named_type = `Clicked`;
        break;
      default:
        break;
      }
      return named_type;
    },
    getNextPage() {
      if (this.loading) return false;

      this.loading = true;

      setTimeout(() => {
        this.getEmailActivity(this.emailActivity.next)
          .then(() => this.loading = false);
      }, 300);
    },
  },

  // Lifecycle
  created() {
    this.getEmailActivity(this.$route.params.id)
      .then(() => this.loading = false);
  },
};
</script>



// WEBPACK FOOTER //
// EmailActivity.vue?4db2bcaa